import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const removeEmployee = async ({ employeeId }: { employeeId: number }) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(routable.getRoute('removeEmployee'), {
        _employeeId_: employeeId,
    });

    try {
        const res = await $api.post<IDataResponse<null>>(url);
        // console.log('res.data:', res.data);
        // console.log('startsWith: ', res?.data?.startsWith('<!DOCTYPE html'));
        // if (
        //     currentEmployeeId === employeeId &&
        //     typeof res.data === 'string' &&
        //     res?.data?.startsWith('<!DOCTYPE html')
        // ) {
        //     console.log('PERFORM RELOAD!');
        //     reloadPage();
        //     throw new Error('HTML response received — probably a session redirect');
        // }

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        throw error;
        // return error.message;
    }
};
